import { createRequestHeaders } from '@zg-rentals/particles-js-requester';

import StringConstants from '../constants/StringConstants';
import { growthRequestClient, requestClient } from '../index';
import { parseResponse } from './requester';

const { POST } = StringConstants;

const api = {
  address: {
    graphQlListing: async (requestBody: string) => {
      const response = await growthRequestClient.post('rental-growth-api/api/graphql/v1/listing', requestBody, {
        headers: {
          ...createRequestHeaders({
            method: POST,
          }),
          ...{
            'Content-Type': 'text/plain',
          },
        },
      });

      return parseResponse(response);
    },
  },
  signUrl: async (url: string) => {
    const response = await requestClient.post(
      'rental-manager-api/api/v1/multibrandSupport/googleMaps',
      { url },
      {
        params: { brandName: 'zillow' },
      },
    );
    return parseResponse(response);
  },
};

export default api;
